import type {FunctionComponent} from 'react'

import {CdToWorkingDir} from './CdToWorkingDir/CdToWorkingDir'
import CdToWorkingDirSuccess from './CdToWorkingDir/CdToWorkingDirSuccess'
import {CliDockerLogin} from './CliDockerLogin/CliDockerLogin'
import CliErrorMessage from './CliErrorMessage/CliErrorMessage'
import {CliToGradle} from './CliToGradle/CliToGradle'
import CliToGradleSuccess from './CliToGradle/CliToGradleSuccess'
import CliToMaven from './CliToMaven/CliToMaven'
import CliToMavenSuccess from './CliToMaven/CliToMavenSuccess'
import type {SmartDetectorProps, SmartDetectorSuccessProps} from './SmartDetectors.types'

export const SmartDetectors: Record<string, FunctionComponent<SmartDetectorProps>> = {
  CdToWorkingDir,
  CliDockerLogin,
  CliErrorMessage,
  CliToGradle,
  CliToMaven,
}

export const SmartDetectorsSuccess: Record<string, FunctionComponent<SmartDetectorSuccessProps>> = {
  CliToMavenSuccess,
  CliToGradleSuccess,
  CdToWorkingDirSuccess,
}
